import Actions             from 'Redux/Actions';
import { SalesRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from, EMPTY }     from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findDailySalesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findDailySalesRequest.type),
    mergeMap(action => {
      return from(
        SalesRepository.findDailySales()
          .then(({ days }) => Actions.findDailySalesSuccess({ days }))
          .catch(error => Actions.findDailySalesFailure({ error })),
      );
    }),
  );
};
